import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@core/services/auth.service';
import { EncryptionStorageService } from '@core/services/encryption-storage.service';

export const authGuard: CanActivateFn = () => {
  const router: Router = inject(Router);
  const authGuardService: AuthService = inject(AuthService);
  const encryptStorage: EncryptionStorageService = inject(EncryptionStorageService);
  const roleName = encryptStorage.getItem('roleName')
  if (authGuardService.isLoggedIn() && (roleName === 'ParkingOwner' || roleName === 'ParkingManager')) {
    return true;

  } router.navigate(['login'])
    return false
};


export const allRoleAccessGuard: CanActivateFn = () => {
  const router: Router = inject(Router);
  const authGuardService: AuthService = inject(AuthService);
  if (authGuardService.isLoggedIn()) {
    return true;

  } router.navigate(['login'])
    return false
};
